<div>
  <nx-pageTitle-box
    [label]="'Vorlage für ' + this.templateName + (this.id ? ' bearbeiten' : ' anlegen')"
    [bcRootLvlLabel]="'Vorlagen'"
    [bcRootLvlPath]="'settings/templates'"
    [icon]="'icon-templates'"
    [iconToolTip]=""></nx-pageTitle-box>
<div class="body flex flex-col white">
  <div [formGroup]="variantFormGroup" class="flex flex-col basis-full border-b">
    <mat-form-field class="basis-full">
      <mat-label>Name</mat-label>
      <input matInput formControlName="name">
    </mat-form-field>
    <mat-checkbox formControlName="isActive" [disabled]="templateVariant?.isActive">
        Aktiv
    </mat-checkbox>
    <ng-container *ngIf="templateType === 'EMAIL'">
      <mat-form-field class="basis-full" >
        <mat-label>Betreff</mat-label>
        <input matInput formControlName="subject">
      </mat-form-field>
      <mat-form-field fxFlex="100%">
        <mat-label>Text</mat-label>
        <textarea matInput class="textarea"
          formControlName="plainText"></textarea>
      </mat-form-field>
    </ng-container>

    <!-- <ngs-code-editor [theme]="theme" [codeModel]="codeModel" [options]="options" (valueChanged)="onCodeChanged($event)" class="border"
    [ngClass]="templateType === 'EMAIL'? 'small': 'large'">
    </ngs-code-editor> -->
    <ace [mode]="'html'" [ngClass]="templateType === 'EMAIL'? 'small': 'large'" id="editor1"  [theme]="'github'" [(value)]="this.codeValue" (textChanged)="onCodeChanged($event)" #editor></ace>

    <hr class="line" *ngIf="templateType !== 'EMAIL'">
    <!-- <div class="flex flex-row">
      <div class="settings flex flex-row gap-25">
        <label>Anhang</label>
      </div>
      <div class="actions basis-1/2 flex flex-row-reverse gap-25">
        <button mat-flat-button *ngIf="isFile" (click)="deletePDF()" color="primary">
          <span>Entfernen</span>
        </button>
        <button mat-flat-button *ngIf="isFile" (click)="downloadPDF()" color="primary">
          <span>Ansicht</span>
        </button>
        <button mat-flat-button type="button" (click)="fileInput.click()" color="primary">
          <span>Upload</span>
          <input #fileInput type="file"  style="display:none;"  (change)="fileChangeEvent($event)" accept="application/pdf"/>
        </button>
        <ng-container *ngIf="uploading">
          <mat-spinner class="spinner" [diameter]="30"></mat-spinner>
        </ng-container>
      </div>
    </div> -->
  </div>
  <div class="basis-1/2 flex items-start  mt-5">
    <button mat-flat-button (click)="saveTemplateVariant()" id="save" color="primary"
      [disabled]="!(variantFormGroup?.valid && !variantFormGroup?.pristine)">Speichern</button>
    <button mat-flat-button (click)="abort()" id="cancel" color="primary">Abbrechen</button>
  </div>
</div>
</div>
